export enum AlignmentOptions {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
  BOTTOM = 'bottom',
  TOP = 'top',
  STRETCH = 'stretch',
}

export enum SlotsAvailability {
  ALL,
  ONLY_AVAILABLE,
}
export enum FilterType {
  SERVICE = 'SERVICE',
  LOCATION = 'LOCATION',
  STAFF_MEMBER = 'STAFF_MEMBER',
}

export type FilterOption = {
  id: string;
  value: string;
  selected: boolean;
};

export type Filter = {
  type: FilterType;
  label: string;
  options: FilterOption[];
};

export enum DisplayStyles {
  UNSET = 'unset',
  NONE = 'none',
}

export enum SettingsTabsTypes {
  Main = 'daily_agenda_widget/main',
  Settings = 'daily_agenda_widget/settings',
  Layout = 'daily_agenda_widget/layout',
  Display = 'daily_agenda_widget/display',
  Design = 'daily_agenda_widget/design',
  Text = 'daily_agenda_widget/text',
}

export enum LayoutTypes {
  LIST = 'LIST',
  SIDE_BY_SIDE = 'SIDE_BY_SIDE',
  OVERLAY = 'OVERLAY',
}
